<button
  *ngIf="!!customers && customers!.length > 0"
  mat-raised-button
  [disabled]="disabled"
  [color]="value ? 'primary' : 'accent'"
  (click)="selectCustomer()"
>
  {{ customerName }}
</button>
